<template>
<div>
  <v-card elevation="0" class="mt-4">
    <v-row >
      <v-col  md="1" class="mrc-text-12-bold text-left">
        ID
      </v-col>
      <v-col  md="2" class="mrc-text-12-bold text-left">
        Booking ID
      </v-col>
      <v-col  md="3" class="mrc-text-12-bold text-left">
        Pickup Time
      </v-col>
      <v-col  md="6" class="mrc-text-12-bold text-left">
        Pickup Location
      </v-col>
    </v-row>
  </v-card>
  <draggable
    :list="driverActiveJobs"
    :disabled="false"
    class="list-group"
    ghost-class="ghost"
    :move="checkMove"
    @update="dragged = true"
    @start="dragging = true"
    @end="dragging = false"
  >
    <v-card
      v-for="(item, index) in driverActiveJobs"
      :key="item.id"
      class="draggable-row my-2"
      :color="index == 0 ? 'green lighten-4' : ''"
    >
      <v-row
      >
        <v-col md="1">
          {{ index+1 }}
        </v-col>
        <v-col md="2">
          <v-btn color="blue lighten-1" small class="px-0 mx-0" text @click="goToBooking(item.booking.id)">
            {{ item.booking.id }}
            <v-icon small>mdi-open-in-new</v-icon>
            <v-chip title="Active Job" x-small color="green lighten-2" class="ml-1" v-if="item.booking.active">
              <v-icon x-small color="red lighten-1">mdi-pin</v-icon>
            </v-chip>
            <v-chip title="Active Job" x-small color="green lighten-2" class="ml-1 mr-2" v-if="!item.booking.active && index == 0">
              <small style="font-size: 8px">active</small>
            </v-chip>
          </v-btn>
        </v-col>
        <v-col md="2">{{ item.booking.pickup_time }}</v-col>
        <v-col md="7">{{ item.booking.pickup_location.description }}</v-col>
      </v-row>
    </v-card>
  </draggable>
  <v-divider></v-divider>
  <v-card class="text-center" color="grey lighten-3" elevation="0">
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="driverActiveJobs.length && driverActiveJobs.length <= 1 || !dragged" small outlined color="indigo darken-1" class="white--text" @click="updateFollowOnJobsPriority">Update</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "DriverActiveJobsList",
  components: {
    draggable
  },
  props: {
   driver: {
     default: null,
     type: Object
   }
  },
  data () {
    return {
      originalOrder: [],
      dragging: false,
      dragged: false,
      draggedIndex: -1,
    }
  },
  computed: {
    driverActiveJobs () {
      return this.$store.getters['activeJob/getDriverActiveJobs']
    }
  },
  methods: {
    callsignPrefixForDriver(driver) {
      var group = "";

      // console.log(driver);
      // console.log("booking group" + this.$store.state.driverGroups.length);

      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driver_group_id == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }

      
      return group;
    },
    updateFollowOnJobsPriority () {
      let data =this.driverActiveJobs.map((entry, index) => {
        return {
          id: entry.  booking.id,
          priority: index+1,
          active: entry.booking.active ? true : false
        }
      })
      console.log("priority ordered data", data )
      this.$store.dispatch('activeJob/updateFollowOnJobsPriority', {driverId: this.driver.id, data: data}).then(response => {
        this.$store.dispatch('activeJob/getDriverActiveJobs', this.driver.id)
        this.$snackbar.success('Driver ' + this.callsignPrefixForDriver(this.driver) + this.driver.callsign + "'s active jobs order updated")
        this.$emit("closeActiveJobsDialog")
      })
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    
    goToBooking(id) {
      return window.open('/bookings/' + id, '_blank')
    },
    fetchFollowOnJobsForTaxi () {
      if (this.taxi != null) {
        this.$store.dispatch('followOnJob/getFollowOnJobsForTaxi', this.taxi.id)
      }
    }
  },
  mounted() {
    this.fetchFollowOnJobsForTaxi()
  }
}
</script>

<style>
.draggable-row {
  cursor: move;
}
</style>